import { render } from "./MainNav2.vue?vue&type=template&id=4da6a91b"
import script from "./MainNav2.vue?vue&type=script&lang=js"
export * from "./MainNav2.vue?vue&type=script&lang=js"

import "./MainNav2.vue?vue&type=style&index=0&id=4da6a91b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__